import * as React from 'react';
import { Button, Popconfirm } from 'antd';
import { useDispatch } from 'react-redux';
import { deletePersistence } from '@store/persistentConfig/actions';
import { ReloadOutlined } from '@ant-design/icons';

function ResetPersistence() {
  const dispatch = useDispatch();

  const clearPersistence = () => {
    dispatch(deletePersistence());
  };

  const shouldDisplayReset = window.location.pathname.includes('preset');

  if (shouldDisplayReset) {
    return (
      <Popconfirm
        title="Reset persistence"
        description="Reset persistence will reset to default config and the changes so far will be lost. Are you sure to proceed?"
        okText="Yes"
        cancelText="No"
        onConfirm={clearPersistence}
      >
        <Button type="text" size="small" icon={<ReloadOutlined />}>
          Reset
        </Button>
      </Popconfirm>
    );
  }
  return null;
}

export default ResetPersistence;
